import styled from '@app/styled';
import { oneLineEllipsis } from '@app/styles';
import { spacing } from '@app/theme';

export const Container = styled.div`
    padding: ${spacing(1, 0)};
    max-height: 215px;
    overflow-y: auto;
`;

export const BranchNameText = styled.div`
    ${oneLineEllipsis};
    max-width: 300px;
    height: 100%;
`;
